import type { OrganizationDetail } from 'models';
import { Card, CollapsibleCard, DocumentLineIcon, RichTextRenderer } from 'ui';
import { Translation } from 'features/translations';

type P = {
  organization: OrganizationDetail;
};

const OrganizationDetailDescription = ({ organization }: P) => (
  <CollapsibleCard card={{ title: <Card.Title icon={<DocumentLineIcon />}>Description</Card.Title> }}>
    <RichTextRenderer data={organization.htmlDescription} />
    <Translation id={organization.id} type="organization" />
  </CollapsibleCard>
);

export default OrganizationDetailDescription;
